/**
 * @documental
 * @export Italic
 * @type
 * typographyComponent
 * @use
 * The `Italic` component should be used to identify text content which should be called out for emphasis.
 * @element
 * em
 * @className
 * italic
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The Italic component properties.
 */

export interface ItalicProps extends BaseProps {}

/**
 * Specifies that text content should be displayed as italic.
 */
export const Italic: FC<PropsWithChildren<ItalicProps>> = (props) => {
  const { children } = props;
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Italic, "italic"] });

  return <em {...baseHtmlProps}>{children}</em>;
};
